import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PartPhotoViewerDialogComponent } from '../../new-catalog/products/part-info/part-photo-viewer-dialog.component';

@NgModule({
  declarations: [PartPhotoViewerDialogComponent],
  imports: [CommonModule, MatButtonModule, MatDialogModule, MatIconModule, MatTooltipModule],
  exports: [PartPhotoViewerDialogComponent]
})
export class PhotoViewerModule {}
